import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {SubmitButton} from "../buttons/SubmitButton";
import {AgencyFormFieldError} from "../agency/AgencyFormFieldError";

export class ClientInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savingChanges: false,
            clientInfo: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    getGeneralData() {
        new APIClient(API_URL + 'client/' + this.props.clientId).call('GET').then((data) => {
            if (data.status === 'OK') {
                this.setState({
                    clientInfo: {
                        name: data.data.name,
                        errors: {}
                    }
                });
            }
        })
    }

    componentDidMount() {
        this.getGeneralData();
    }

    _editClientUrl() {
        return API_URL + 'client/edit/' + this.props.clientId;
    }

    handleSubmit() {
        this.setState({savingChanges: true});
        new APIClient(this._editClientUrl()).call('POST', {
            'name': this.state.clientInfo.name
        }).then((data) => {
            this.setState({savingChanges: false});
            let errors = [];
            if (data.status === 'ERROR') {
                errors = JSON.parse(data.errors);
            } else if (data.status === 'OK') {
                alert('Todos los cambios fueron guardados');
            }
            this.setState({
                clientInfo: {
                    ...this.state.clientInfo,
                    errors: errors
                }
            });
        });
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.value;

        this.setState({
            clientInfo: {
                ...this.state.clientInfo,
                [name]: value
            }
        });
    }

    renderSaveButton() {
        if (this.state.savingChanges) {
            return <Spinner color="positive small"/>;
        } else {
            return <SubmitButton onClick={this.handleSubmit} value="Guardar"/>;
        }
    }

    renderClientInfo() {
        if (this.state.clientInfo !== null) {

            return (
                <div className="box">
                    <header className="box-header">
                        <h2 className="box-title">Datos principales</h2>
                    </header>
                    <div className="form-row">
                        <label><span title="Este campo es obligatorio">*</span>Nombre:</label>
                        <input onChange={this.handleChange} name="name" type="text"
                               value={this.state.clientInfo.name}/>
                        <AgencyFormFieldError errors={this.state.clientInfo.errors} fieldName="name"/>
                    </div>
                    <div className="submit-row">
                        {this.renderSaveButton()}
                    </div>
                </div>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    render() {
        return (
            <form className="section-body-item -slim">
                {this.renderClientInfo()}
            </form>
        )
    }
}
